function fetchColorSwatches() {
    //document.addEventListener("DOMContentLoaded", function() {
        // Define a function to apply styles
        function applySwatchStyles(swatches) {
            let styles = '';
    
            swatches.forEach(swatch => {
                const urlFriendlyName = swatch.name
                .toLowerCase()
                .replace(/\s+/g, '-')  // Replace spaces with hyphens
                .replace(/[()]/g, '')  // Remove parentheses
                .replace(/-*\w+\s*$/, '');  // Remove trailing abbreviation
        
                styles += `
                    .swatch-panda [class*="${urlFriendlyName}"] label {
                        background-color: ${swatch.color};
                    }
                `;
            });
    
            // Create a style element and append all the styles at once
            const styleElement = document.createElement('style');
            styleElement.textContent = styles;
            document.head.appendChild(styleElement);
        }
    
        // Fetch the swatch JSON data
        fetch('//www.capitalbadges.co.uk/cdn/shop/t/105/assets/swatch_colors.json?v=64006500859120596111790265835')
            .then(response => {
                // Check if the request was successful
                if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                return response.json(); // Parse the JSON
            })
            .then(swatches => {
                try {
                    // Ensure the JSON is valid and contains the expected structure
                    if (!Array.isArray(swatches)) {
                        throw new Error('Invalid JSON structure: Expected an array of swatches');
                    }
                    // Apply the swatch styles
                    applySwatchStyles(swatches);
                } catch (jsonError) {
                    console.error('Error processing JSON:', jsonError.message);
                    // Optional: Display a user-friendly message or take fallback action
                }
            })
            .catch(error => {
                console.error('Failed to load swatch data:', error.message);
                // Optional: Display a user-friendly message or take fallback action
            });
    //});
}

fetchColorSwatches();